// src/components/ProtectedAdminRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { hasAdminPrivileges } from '../utils/permissionsClient';
import LoginPage from './SignInSide';

const ProtectedAdminRoute = ({ element: Component }) => {
    const { isAuthenticated, user } = useSelector((state) => state.auth);

    if (!isAuthenticated) return <LoginPage />;
    if (!user || !hasAdminPrivileges(user)) {
        return <div style={{ padding: 32 }}>403 Forbidden  Admins only</div>;
    }
    return <Component />;
};

export default ProtectedAdminRoute;
